import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import ModalWapper from "./ModalWapper";
import { useSelector } from "react-redux";

const ShareModal = ({
  id,
  isPromoter,
  show,
  setShow,
  promoterCommission,
  setId,
}) => {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const [linkCopied, setLinkCopied] = useState(false);
  const [sharedUrl, setSharedUrl] = useState("");
  const params = useParams();
  const vendorId = params?.vendorId;

  const handleCopyTextFromArea = () => {
    const area = document.querySelector("#clipboard-area");
    area.select();
    document.execCommand("copy");
    setLinkCopied(true);
  };

  useEffect(() => {
    if (show === true) {
      setSharedUrl(
        `${process.env.REACT_APP_Home_URL}/merch/product/${id}` +
          (isPromoter && promoterCommission
            ? `?referralId=${vendorId ?? userInfo?._id}`
            : "")
      );
    } else {
      setId("");
    }
  }, [show]);

  return (
    <div>
      <ModalWapper
        show={show}
        setShow={setShow}
        title="Share product url"
        isPromotion={true}
      >
        <p>Share this product with your friends</p>
        <p
          style={{
            color: "#2aa8f2",
            fontSize: "14px",
          }}
        >
          {isPromoter &&
            promoterCommission &&
            `You will get
          ${promoterCommission && ` ${promoterCommission} %`} commission for
          sharing this product after matching the requirements of privacy policy`}
        </p>
        <div className="copy-wraper">
          <input
            className="event-link-copy"
            id="clipboard-area"
            width={"100%"}
            defaultValue={sharedUrl || ""}
          />
          <div
            className="clipboard-icon"
            style={{ background: `${linkCopied ? "green" : "#2aa8f2"}` }}
            onClick={() => handleCopyTextFromArea()}
          >
            <i
              className={`fa fa-light ${linkCopied ? "fa-check" : "fa-paste"}`}
            ></i>
          </div>
        </div>
      </ModalWapper>
    </div>
  );
};

export default ShareModal;
